import { useMemo } from 'react';
import { useToast, ToastPosition } from '@/shared/contexts/ToastContext';
import Toast from './Toast';

const ToastContainer = () => {
  const { toasts, removeToast } = useToast();

  const groupedToasts = useMemo(() => {
    const grouped: Record<ToastPosition, typeof toasts> = {
      'top-left': [],
      'top-center': [],
      'top-right': [],
      'bottom-left': [],
      'bottom-center': [],
      'bottom-right': []
    };
    toasts.forEach(toast => grouped[toast.position].push(toast));
    return grouped;
  }, [toasts]);

  if (toasts.length === 0) return null;

  return (
    <>
      {Object.entries(groupedToasts).map(([position, positionToasts]) => {
        if (positionToasts.length === 0) return null;
        return (
          <div
            key={position}
            className={`toast-container toast-container--${position}`}
          >
            {positionToasts.map(toast => (
              <Toast
                key={toast.id}
                toast={toast}
                onRemove={() => removeToast(toast.id)}
              />
            ))}
          </div>
        );
      })}
    </>
  );
};

export default ToastContainer;
